import { render, staticRenderFns } from "./SCol.vue?vue&type=template&id=4bf5231c&scoped=true"
import script from "./SCol.vue?vue&type=script&lang=js"
export * from "./SCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5231c",
  null
  
)

export default component.exports